import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'navigation_tree_ux-categories_menu_button-view';

/**
 * Track viewing the button that opens the categories menu
 */
export function trackNavigationTreeUxCategoriesMenuButtonView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
